import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import StatusBadge from "@/components/StatusBadge";
import { toast } from "sonner";

export default function AdminUsers() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("pending");

  const load = () => api.get("/admin/users").then((r) => setItems(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const filtered = items.filter((u) => (tab === "all" ? u.role !== "admin" : u.status === tab && u.role !== "admin"));

  const decide = async (uid, decision) => {
    try { await api.post(`/admin/users/${uid}/decision`, { decision }); toast.success(`User ${decision}`); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <DashboardLayout title="Users & CRM">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="user-tabs">
          <TabsTrigger value="pending" data-testid="tab-pending">Pending</TabsTrigger>
          <TabsTrigger value="approved" data-testid="tab-approved">Approved</TabsTrigger>
          <TabsTrigger value="rejected" data-testid="tab-rejected">Rejected</TabsTrigger>
          <TabsTrigger value="all" data-testid="tab-all">All</TabsTrigger>
        </TabsList>
        <TabsContent value={tab} className="mt-6">
          <Card>
            <CardHeader><CardTitle className="font-heading tracking-tight">{filtered.length} user{filtered.length===1?"":"s"}</CardTitle></CardHeader>
            <CardContent>
              {filtered.length === 0 ? (
                <div className="py-10 text-center text-muted-foreground text-sm" data-testid="users-empty">No users.</div>
              ) : (
                <Table data-testid="users-table">
                  <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Email</TableHead><TableHead>Role</TableHead><TableHead>Company</TableHead><TableHead>Country</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Actions</TableHead></TableRow></TableHeader>
                  <TableBody>
                    {filtered.map((u) => (
                      <TableRow key={u.id} data-testid={`user-row-${u.id}`}>
                        <TableCell className="font-medium text-secondary">{u.name}</TableCell>
                        <TableCell>{u.email}</TableCell>
                        <TableCell className="capitalize">{u.role}</TableCell>
                        <TableCell>{u.company_name || "—"}</TableCell>
                        <TableCell>{u.country || "—"}</TableCell>
                        <TableCell><StatusBadge status={u.status} /></TableCell>
                        <TableCell className="text-right space-x-2">
                          {u.status !== "approved" && <Button size="sm" onClick={() => decide(u.id, "approved")} data-testid={`approve-${u.id}`}>Approve</Button>}
                          {u.status !== "rejected" && <Button size="sm" variant="outline" onClick={() => decide(u.id, "rejected")} data-testid={`reject-${u.id}`}>Reject</Button>}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </DashboardLayout>
  );
}
